// import React, { useState, useEffect } from "react";
// import { Modal } from "react-bootstrap";
// import { axiosInstance } from "../component/Api/instance";
// import { useNavigate } from "react-router-dom";
// import { useContext } from "react";
// import { UserContext } from "../Context";

// const TOTAL_PARTS = 5;
// const PART_DURATION = 18 * 60;

// const CountdownTimer = () => {
//   const [currentPart, setCurrentPart] = useState(1);
//   const { timeLeft, setTimeLeft } = useContext(UserContext);
//   const email = localStorage.getItem("userMail");
//   const [modalIsOpen, setModalIsOpen] = useState(false);
//   // const [part, setPart] = useState(1);
//   const navigate = useNavigate();
//   // useEffect(() => {
//   const fetchTimeDifference = async (time) => {
//     try {
//       const response = await axiosInstance.post(`get/U_ViewPrelimsTimer.php`, {
//         userId: email,
//         part: time,
//       });
//       console.log(response.data.time);

//       if (!response || !response.data || !response.data.time) {
//         console.error("Invalid API response:", response);
//         return;
//       }

//       const serverTime = new Date(response.data.time);
//       const currentTime = new Date();
//       const timeDifference = Math.floor((serverTime - currentTime) / 1000); // difference in seconds
//       // setTimeLeft(timeDifference > 0 ? timeDifference : 0);
//       setTimeLeft(PART_DURATION);
//     } catch (error) {
//       console.error("Error fetching time difference:", error);
//       setTimeLeft(PART_DURATION);
//     }
//   };

//   //     fetchTimeDifference(1);
//   // }, []);

//   useEffect(() => {
//     fetchTimeDifference(currentPart);
//   }, [currentPart]);

//   useEffect(() => {
//     if (timeLeft === 0) {

//        if (currentPart < TOTAL_PARTS) {
//       setModalIsOpen(true);
//        }
//       setTimeout(() => {
//          if (currentPart < TOTAL_PARTS) {
//         setModalIsOpen(false);
//         if (currentPart < 5) {
//           setCurrentPart((prevPart) => prevPart + 1);
//         }
//       }else{
//         console.log("test completed")
//       }
//       }, []);
//       return;
//     }

//     const timer =
//       (timeLeft > 0 && currentPart < 5)||(currentPart === 5 && timeLeft > 1)?
//       setInterval(() => {
//         setTimeLeft((prevTime) => prevTime - 1);
//       }, 1000)
//       :null;
//     return () => clearInterval(timer);
//   }, [timeLeft]);

//   const formatTime = (seconds) => {
//     const hrs = Math.floor(seconds / 3600);
//     const mins = Math.floor((seconds % 3600) / 60);
//     const secs = seconds % 60;
//     return `${hrs.toString().padStart(2, "0")}:${mins
//       .toString()
//       .padStart(2, "0")}:${secs.toString().padStart(2, "0")}`;
//   };

//   return (
//     <div>
//       {timeLeft !== null ? (
//         <p>TIME: {formatTime(timeLeft)}</p>
//       ) : (
//         <p>Loading...</p>
//       )}
//       <Modal
//         isOpen={modalIsOpen}
//         onRequestClose={() => setModalIsOpen(false)}
//         contentLabel="Times Up!"
//       >
//         <div>
//           <p>Times Up!</p>
//         </div>
//       </Modal>
//     </div>
//   );
// };

// export default CountdownTimer;

import React, { useState, useEffect, useContext } from "react";
import { Modal } from "react-bootstrap";
import { axiosInstance } from "../component/Api/instance";
import { UserContext } from "../Context";
import PauseIcon from "@mui/icons-material/Pause";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";


const TOTAL_PARTS = 5;
const PART_DURATION = 18 * 60; 

const CountdownTimer = () => {
  const [currentPart, setCurrentPart] = useState(1);
  const { timeLeft, setTimeLeft } = useContext(UserContext);
  const email = localStorage.getItem("userMail");

 const { isPaused, setIsPaused } = useContext(UserContext);

  const [modalIsOpen, setModalIsOpen] = useState(false);


  useEffect(() => {
    const savedTime = localStorage.getItem(`timer_part_${currentPart}`);

    if (savedTime) {
      setTimeLeft(Number(savedTime));
    } else {
      fetchTimeDifference(currentPart);
    }
  }, [currentPart]);

  const fetchTimeDifference = async (part) => {
    try {
      const response = await axiosInstance.post(`get/U_ViewPrelimsTimer.php`, {
        userId: email,
        part,
      });

      if (response?.data?.time) {
        setTimeLeft(PART_DURATION);
        localStorage.setItem(`timer_part_${part}`, PART_DURATION);
      } else {
        setTimeLeft(PART_DURATION);
      }
    } catch (error) {
      console.error("Error fetching time:", error);
      setTimeLeft(PART_DURATION);
    }
  };

  useEffect(() => {
    fetchTimeDifference(currentPart);
  }, [currentPart]);

  useEffect(() => {
    if (isPaused) return; 

    if (timeLeft > 0) {
      const interval = setInterval(() => {
        setTimeLeft((prev) => {
          const updated = prev - 1;
          localStorage.setItem(`timer_part_${currentPart}`, updated);
          return updated;
        });
      }, 1000);

      return () => clearInterval(interval);
    }

   
    if (timeLeft === 0) {
      if (currentPart < TOTAL_PARTS) {
        setModalIsOpen(true);
        setTimeout(() => {
          setModalIsOpen(false);
          setCurrentPart((p) => p + 1);
        }, 1200);
      } else {
        console.log("Test Completed");
      }
    }
  }, [isPaused, timeLeft, currentPart]);


  const formatTime = (seconds) => {
    const hrs = Math.floor(seconds / 3600);
    const mins = Math.floor((seconds % 3600) / 60);
    const secs = seconds % 60;

    return `${hrs.toString().padStart(2, "0")}:${mins
      .toString()
      .padStart(2, "0")}:${secs.toString().padStart(2, "0")}`;
  };

  return (
    <div style={{ textAlign: "center", display: "flex" }}>
      <p style={{ fontWeight: "bold", fontSize: "18px", marginBottom: "5px" }}>
        TIME: {formatTime(timeLeft ?? 0)}
      </p>
      <button
        onClick={() => setIsPaused(!isPaused)}
        style={{
          background: "white",
          border: "none",
          color: "black",
          cursor: "pointer",
          marginBottom: "14px",
          marginLeft:"20px"
        }}
      >
        {isPaused ? (
          <PlayArrowIcon style={{ fontSize: "20px" }} />
        ) : (
          <PauseIcon style={{ fontSize: "20px" }} />
        )}
      </button>

      <Modal show={modalIsOpen} centered>
        <div style={{ padding: "20px", textAlign: "center" }}>
          <p style={{ fontWeight: "bold", fontSize: "18px" }}>Time's Up!</p>
        </div>
      </Modal>
    </div>
  );
};

export default CountdownTimer;
